import { useState, useEffect } from 'react';
import { fetchRandomQuote, getErrorMessage } from '../api/quotes';

const toLocalDate = (d = new Date()) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const useDailyQuote = () => {
    const [quote, setQuote] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const today = toLocalDate();

        try {
            const cached = JSON.parse(localStorage.getItem('captions_daily') || 'null');
            if (cached?.date === today && cached?.quote) {
                setQuote(cached.quote);
                setLoading(false);
                return;
            }
        } catch {}

        fetchRandomQuote()
            .then((item) => {
                const q = { text: item.quote, author: item.author };
                localStorage.setItem('captions_daily', JSON.stringify({ date: today, quote: q }));
                setQuote(q);
            })
            .catch((err) => setError(getErrorMessage(err)))
            .finally(() => setLoading(false));
    }, []);

    return { quote, loading, error };
};

export default useDailyQuote;
